<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="equipmentItemFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                equipmentItemFileForm: () => import('../forms/EquipmentItemFileForm'),
                headers: [
                    { text: 'Equipment Item', value: 'equipmentItemId', table: 'equipmentItems', form: () => import('../forms/EquipmentItemForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    equipmentItems: [],
                    files: [],
                    items: []
                },
                sorting: [
                    { column: "equipmentItemId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'equipmentItemFiles',
                editPageName: 'equipmentItemFile',
                apiMethod: 'EquipmentItemFiles',
                claimName: 'EquipmentItemFiles',
                formTitle: 'Equipment Item File',
                excelTitle: 'Equipment Item Files',
                hasEditPage: false,
            }
        },
    };
</script>
